var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLockFilled = function SvgLockFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 8,
    viewBox: "0 0 11 13",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.667 4.5V2.75C2.667 1.06 4.05 0 5.5 0s2.833 1.06 2.833 2.75V4.5h-1V2.75C7.333 1.66 6.5 1 5.5 1s-1.833.66-1.833 1.75V4.5ZM2 4.5h7a2 2 0 0 1 2 2V11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLockFilled);
export default ForwardRef;